// import React from "react";

// function ReturnAdminProcess() {
//   return <div></div>;
// }

// export default ReturnAdminProcess;

import React, { useState, useEffect } from "react";
import "./ReturnAdminProcess.scss";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const ReturnAdminProcess = () => {
  const [value, setValue] = useState(0);

  const [order, setOrder] = useState([]);
  const userId = localStorage.getItem("raer_id");
  const { returnOrderId } = useParams();
  const navigate = useNavigate();
  const tokena = localStorage.getItem("raer_token");
  const raerAcess = localStorage.getItem("raerAcess");
  useEffect(() => {
    console.log(raerAcess);
    if (raerAcess !== "1" || !tokena) {
      navigate("/login");
      return;
    }
  });

  const getOrderDetails = () => {
    const config = {
      url:
        process.env.REACT_APP_BASE_URL +
        `return/getReturnOrderById/${returnOrderId}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");

        if (response?.data?.status == true) {
          setOrder(response?.data?.data);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const acceptHandler = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/ship/createRet`,
      method: "post",
      data: {
        returnOrderId: returnOrderId,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response?.data?.status);

        if (response?.data?.status == true) {
          toast.success("Order Accepted", {
            position: "bottom-right",
            autoClose: 4000,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          });
          navigate("/dashboard");
          window.scroll({
            top: 0,
            behavior: "smooth",
          });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const PayNowRefund = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/pay/refund`,
      method: "post",
      data: {
        returnOrderId: returnOrderId,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response?.data?.status);

        if (response?.data?.status == true) {
          toast.success("Payment Done", {
            position: "bottom-right",
            autoClose: 4000,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          });
          navigate("/dashboard");
          window.scroll({
            top: 0,
            behavior: "smooth",
          });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    getOrderDetails();
  }, []);

  return (
    <div>
      <div className="APP-main">
        <div className="AP-outer">
          <div className="AP-inner">
            <div className="top row">
              <div className="top-part-1 col-6">
                <h5>Buyer Information</h5>
                <div>
                  <p>
                    <span>Name:</span>{" "}
                    {order?.orderId?.billing_details?.fullName}
                  </p>
                  <p>
                    <span>Email:</span>
                    {order?.orderId?.billing_details?.email}
                  </p>
                </div>
                <p>
                  <span>Phone:</span> {order?.orderId?.billing_details?.phone}
                </p>
              </div>
              <div className="top-part-2 col-6">
                <h5>Billing To</h5>
                <p>
                  <span>address: </span>{" "}
                  {order?.orderId?.billing_details?.address}
                </p>
                <p>
                  <span>city:</span> {order?.orderId?.billing_details?.city}
                </p>
                <p>
                  <span>landmark:</span>{" "}
                  {order?.orderId?.billing_details?.landmark}
                </p>
                <p>
                  <span>state:</span> {order?.orderId?.billing_details?.state}
                </p>
              </div>
            </div>
            <div className="mid">
              <div className="mid-outer">
                <div className="mid-inner">
                  <div className="mid-head row">
                    <div className="part-head col-1">
                      <p>Serial No. </p>
                    </div>
                    <div className="part-head col-2">
                      <p>Product Name </p>
                    </div>
                    <div className="part-head col-2">
                      <p>Size </p>
                    </div>
                    <div className="part-head col-1">
                      <p>Unit </p>
                    </div>
                    <div className="part-head col-1">
                      <p>Price (INR)</p>
                    </div>
                    <div className="part-head col-2">
                      <p>Total Amount</p>
                    </div>
                    <div className="part-head col-2">
                      <p>SKU</p>
                    </div>
                  </div>
                  <div className="mid-body">
                    <div className="mid-body-inner-1 ">
                      {order?.products?.map((product, index) => {
                        return (
                          <div className="mid-body-inner-1 row">
                            <div className="part-body col-1">
                              <p>{index + 1}</p>
                            </div>
                            <div className="part-body col-2">
                              <p>{product?.productId?.productName} </p>
                            </div>
                            <div className="part-body col-2">
                              <p>{product?.size} </p>
                            </div>
                            <div className="part-body col-1">
                              <p>{product?.count}</p>
                            </div>
                            <div className="part-body col-1">
                              <p>{product?.productId?.price} </p>
                            </div>
                            <div className="part-body col-2">
                              <p>{product?.price * product?.count}</p>
                            </div>
                            <div className="part-body col-2">
                              <p>{product?.sku} </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <div className="bottom-outer">
                <div className="bottom-inner">
                  <div className="head">
                    <h5>Shipping From:</h5>
                  </div>
                  <div className="body">
                    <p>
                      381, M.G Road, Gorakund, Indore, Madhya Pradesh, 452001.
                    </p>
                    <p>
                      <span>Phone: </span>+91 9981914176
                    </p>
                    <p>
                      <span>Email: </span>Raerofficialclothing@gmail.com
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              {order?.orderStatus === "REJECTED" ? (
                <div className="accept-reject-button-rejection">
                  <span>
                    The order was Rejected , and Refund was Initiated{" "}
                  </span>
                </div>
              ) : (
                <div>
                  {value == 0 && (
                    <div className="accept-reject-button">
                      {order?.orderStatus === "COMPLETED" ? (
                        <div className="accept-reject-button-rejection">
                          <span>
                            The order is completed , and Pickup is scheduled
                          </span>
                        </div>
                      ) : (
                        <div>
                          {" "}
                          <button
                            type="button"
                            class="btn btn-primary accept-button m-2"
                            onClick={acceptHandler}
                          >
                            Accept
                          </button>
                          <button
                            type="button"
                            class="btn btn-secondary reject-button m-2"
                          >
                            Reject
                          </button>
                          {order?.transactionStatus != "completed" && (
                            <button
                              type="button"
                              class="btn btn-secondary reject-button m-2"
                              onClick={PayNowRefund}
                            >
                              Pay Now
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnAdminProcess;
